import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './device-show-modal';

class DeviceShowButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean, attribute: false },
      label: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles];
  }

  render() {
    return html`
      <button class="button button--tertiary" @click="${this._onClick}">${this.label || 'Show'}</button>
      <device-show-modal
        .href="${this.href}"
        .hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></device-show-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('device-show-button', DeviceShowButton);
